import { jsx } from 'react/jsx-runtime';
import CircularProgress from '@mui/material/CircularProgress';
import LottieDefault from 'react-lottie';
import branclubloading from '../../../assets/lottie/brandclub_logo_load.js';
import EllipsisBlueLoading from '../../../assets/lottie/ellipsis_darkblue.js';
import EllipsisLoading from '../../../assets/lottie/ellipsis.js';

const Lottie = LottieDefault;
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: branclubloading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
const ellipsisBlueOptions = {
    loop: true,
    autoplay: true,
    animationData: EllipsisBlueLoading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
const ellipsisOptions = {
    loop: true,
    autoplay: true,
    animationData: EllipsisLoading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
const Loading = ({ star, ellipsisBlue, size, ellipsis }) => {
    return (jsx("div", Object.assign({ style: {
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        } }, { children: ellipsisBlue ? (jsx(Lottie, { options: ellipsisBlueOptions, isClickToPauseDisabled: true, width: size !== null && size !== void 0 ? size : 30, height: size !== null && size !== void 0 ? size : 30 })) : ellipsis ? (jsx(Lottie, { options: ellipsisOptions, isClickToPauseDisabled: true, width: size !== null && size !== void 0 ? size : 30, height: size !== null && size !== void 0 ? size : 30 })) : star ? (jsx(Lottie, { options: defaultOptions, width: 200 })) : (jsx(CircularProgress, { size: 100 })) })));
};
const ButtonLoadingEllipsis = ({ baseFontSize = 12, blue }) => {
    const ellipsisContainerSize = baseFontSize * 1.4;
    const ellipsisSize = baseFontSize * 2.6;
    const yOffset = ellipsisSize / 10;
    return (jsx("div", Object.assign({ style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            width: ellipsisContainerSize,
            height: ellipsisContainerSize,
            minWidth: ellipsisContainerSize,
            minHeight: ellipsisContainerSize,
        } }, { children: jsx("div", Object.assign({ style: {
                position: 'absolute',
                width: ellipsisSize,
                height: ellipsisSize,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: `translateY(${yOffset}px)`,
            } }, { children: jsx(Loading, { ellipsis: !blue, ellipsisBlue: blue, size: ellipsisSize }) })) })));
};

export { ButtonLoadingEllipsis, Loading };
//# sourceMappingURL=index.js.map
